// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.board_page__-3I0O {
  padding: 16px 16px 0 16px;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.board_pageDrawerOpen__cDIS0 {
  position: relative;
}

.board_pageDrawerOpen__cDIS0::before {
  content: "";
  position: fixed;
  top: 52px;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--bg-backdrop);
  z-index: 25;
  pointer-events: none;
}

.board_createIssue__JNWCD {
  position: absolute;
  right: 3rem;
  bottom: 3rem;
  z-index: 1000;
  width: 7rem;
  height: 4rem;
  border-radius: 14px;
  border: none;
  background: var(--button-bg-gradient);
  color: var(--text-on-primary);
  font-weight: 650;
  letter-spacing: 0.01em;
  box-shadow: 6px 6px 14px rgba(0, 0, 0, 0.45), -6px -6px 14px rgba(255, 255, 255, 0.06), inset 1px 1px 2px rgba(255, 255, 255, 0.08), inset -1px -1px 2px rgba(0, 0, 0, 0.2);
  transition: transform 120ms ease, box-shadow 120ms ease;
  cursor: pointer;
}

.board_createIssue__JNWCD:hover {
  transform: translateY(-1px);
  box-shadow: 8px 8px 18px rgba(0, 0, 0, 0.5), -8px -8px 18px rgba(255, 255, 255, 0.08), inset 1px 1px 2px rgba(255, 255, 255, 0.1), inset -1px -1px 2px rgba(0, 0, 0, 0.2);
}

.board_createIssue__JNWCD:active {
  transform: translateY(0px);
  box-shadow: inset 4px 4px 10px rgba(0, 0, 0, 0.4), inset -4px -4px 10px rgba(255, 255, 255, 0.05);
}

.internal-root[data-theme="light"] .board_createIssue__JNWCD {
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 1px 3px rgba(0, 0, 0, 0.1);
}

.internal-root[data-theme="light"] .board_createIssue__JNWCD:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2), 0 2px 4px rgba(0, 0, 0, 0.12);
}

.internal-root[data-theme="light"] .board_createIssue__JNWCD:active {
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15);
}

.board_issueTitleContainer__kM-Wj {
  margin-bottom: 12px;
}

.board_issueTitleText__aNDvW {
  background: var(--fill-subtle);
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-default);
  border-radius: 6px;
  resize: none;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 600;
  min-height: 42px;
  height: 42px; /* Force single line initially, though it's a textarea */
  transition: border-color 0.15s ease, background-color 0.15s ease;
  font-family: inherit;
}

.board_issueTitleText__aNDvW:focus {
  outline: none;
  border-color: var(--border-focus);
  background: var(--fill-light);
}

.board_issueDescriptionContainer__cr-l5 {
  margin-bottom: 8px;
}

.board_issueDescriptionText__Xa8Q4 {
  background: var(--fill-subtle);
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-default);
  border-radius: 6px;
  resize: vertical;
  color: var(--text-primary);
  font-size: 13px;
  min-height: 120px;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  font-family: inherit;
}

.board_issueDescriptionText__Xa8Q4:focus {
  outline: none;
  border-color: var(--border-focus);
  background: var(--fill-light);
}

.board_issueTitleText__aNDvW::placeholder,
.board_issueDescriptionText__Xa8Q4::placeholder {
  color: var(--text-muted);
  opacity: 0.6;
}

.board_createIssueActions__FDPu2 {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border-subtle);
}

.board_createIssuePrimary__tKbz9 {
  background-color: var(--primary);
  color: #fff;
  border: 1px solid transparent;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.board_createIssuePrimary__tKbz9:hover {
  filter: brightness(1.1);
  transform: translateY(-1px);
}

.board_createIssuePrimary__tKbz9:active {
  transform: translateY(0px);
}

.board_createIssuePrimary__tKbz9:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  filter: grayscale(0.5);
}

.board_createIssueError__yn2Te {
  color: var(--color-error);
  margin-top: 8px;
}

.board_header__S3U3u {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.board_backArrowLink__XkrUX {
  display: flex;
  justify-content: center;
  align-items: center;
}

.board_title__jOGAN {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-muted);
}

.board_backArrow__aLVaD {
  height: 16px;
  width: 16px;
  margin-right: 5px;
}

.board_error__bWV7J {
  color: var(--color-error);
  margin: 8px 0 12px;
}

.board_filterOptionsContainer__Jaict {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.board_filterOption__vRdsO {
  background: var(--bg-base);
  color: var(--text-muted);
  border-radius: 8px;
  padding-inline: 0.8rem;
  padding-block: 0.5rem;
  cursor: pointer;
  font-size: 13px;
  border: 1px solid var(--border-color);
  will-change: transform;
  min-width: 2.5rem;
}

.board_filterOption__vRdsO:hover:not(.board_filterOptionActive__WNP1c) {
  background: linear-gradient(var(--bg-raised), var(--bg-surface)) padding-box, linear-gradient(to bottom, var(--highlight-color), var(--border-color)) border-box;
  /* Ensure the border is transparent so the gradient shows through */
  border-color: transparent;
}

.board_filterOptionActive__WNP1c {
  background-color: var(--primary);
  color: #fff;
}

.board_boardContainer__4EBGA {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.board_board__Hd6z- {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 280px;
  gap: 12px;
  flex: 1 1;
  min-height: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  padding-bottom: 8px;
  scrollbar-gutter: stable;
}

.board_column__gyRV3 {
  background: var(--fill-subtle);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.board_column__gyRV3:hover {
  background: var(--bg-raised-purple);
  border: 1px solid var(--border-color);
}

.board_columnHeader__ZwsL9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border-subtle);
}

.board_columnTitle__TyArK {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-strong);
  /* Default: make all column icons brighter */
  --board-icon-filter: brightness(1.25) saturate(1.6) contrast(1.15);
}

/* Per-column icon filter hook (override in CSS) */
.board_columnTitle__TyArK[data-state-key="in progress"] {
  --board-icon-filter: brightness(0) saturate(100%) invert(99%) sepia(65%)
    saturate(5941%) hue-rotate(323deg) brightness(115%) contrast(95%);
}

.board_columnTitle__TyArK[data-state-key="in review"] {
  --board-icon-filter: brightness(0) saturate(100%) invert(51%) sepia(67%)
    saturate(381%) hue-rotate(70deg) brightness(120%) contrast(95%);
}

.board_columnTitle__TyArK[data-state-key=done] {
  --board-icon-filter: brightness(0) saturate(100%) invert(44%) sepia(78%)
    saturate(482%) hue-rotate(197deg) brightness(115%) contrast(95%);
}

.board_columnTitle__TyArK[data-state-key=canceled],
.board_columnTitle__TyArK[data-state-key=cancelled],
.board_columnTitle__TyArK[data-state-key=duplicate] {
  --board-icon-filter: brightness(0) saturate(100%) invert(74%) sepia(7%)
    saturate(619%) hue-rotate(175deg) brightness(115%) contrast(95%);
}

.board_columnTitle__TyArK[data-state-key=triage] {
  --board-icon-filter: brightness(0) saturate(100%) invert(56%) sepia(55%)
    saturate(1002%) hue-rotate(331deg) brightness(120%) contrast(95%);
}

.board_columnTitle__TyArK[data-state-key=todo] {
  --board-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)
    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);
}

.board_columnTitle__TyArK[data-state-key=backlog] {
  --board-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)
    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);
}

.board_columnTitle__TyArK[data-state-key="extended features"] {
  --board-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)
    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);
}

.board_columnIcon__Ofna6 {
  width: 14px;
  height: 14px;
  opacity: 0.9;
  filter: var(--board-icon-filter, none);
}

.internal-root[data-theme="light"] .board_columnTitle__TyArK {
  --board-icon-filter: brightness(0.8) saturate(1.4) contrast(1.1);
}
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key="in progress"] {
  --board-icon-filter: brightness(0) saturate(100%) invert(65%) sepia(65%)
    saturate(5941%) hue-rotate(323deg) brightness(85%) contrast(95%);
}
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key="in review"] {
  --board-icon-filter: brightness(0) saturate(100%) invert(42%) sepia(67%)
    saturate(500%) hue-rotate(70deg) brightness(105%) contrast(90%);
}
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key=done] {
  --board-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(80%)
    saturate(1500%) hue-rotate(197deg) brightness(85%) contrast(100%);
}
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key=canceled],
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key=cancelled],
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key=duplicate] {
  --board-icon-filter: brightness(0) saturate(100%) invert(40%) sepia(7%)
    saturate(619%) hue-rotate(175deg) brightness(90%) contrast(95%);
}
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key=triage] {
  --board-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(55%)
    saturate(1002%) hue-rotate(331deg) brightness(90%) contrast(95%);
}
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key=todo],
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key=backlog],
.internal-root[data-theme="light"] .board_columnTitle__TyArK[data-state-key="extended features"] {
  --board-icon-filter: brightness(0) saturate(100%) invert(30%) sepia(1%)
    saturate(209%) hue-rotate(72deg) brightness(70%) contrast(100%);
}

.board_columnCount__vKbS7 {
  font-size: 12px;
  color: var(--text-tertiary);
}

.board_columnBody__XtBJh {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  /* Keep layout stable even when no overflow */
  scrollbar-gutter: stable;
  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: transparent transparent;
  /* WebKit (Chrome/Safari/Edge) */
}
.board_columnBody__XtBJh::-webkit-scrollbar:vertical {
  width: 10px;
}
.board_columnBody__XtBJh::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 999px;
  border: 2px solid transparent;
}
.board_columnBody__XtBJh::-webkit-scrollbar-track {
  background: transparent;
}
.board_columnBody__XtBJh:hover {
  scrollbar-color: var(--highlight-color) transparent;
}
.board_columnBody__XtBJh:hover::-webkit-scrollbar-thumb {
  background-color: var(--highlight-color);
  border-color: var(--bg-base);
}

.board_card__b9Jrk {
  cursor: pointer;
  padding: 10px;
}

.board_card__b9Jrk:hover {
  filter: brightness(1.03);
}

.internal-root[data-theme="light"] .board_card__b9Jrk:hover {
  filter: brightness(0.97);
}

.board_cardTop__ALEuM {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.board_identifier__viOJQ {
  font-size: 11px;
  color: var(--text-tertiary);
}

.board_cardTitle__2iU7O {
  font-size: 13px;
  line-height: 1.35;
  color: var(--text-heading);
}

.board_loadingContainer__35s18 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  width: 100%;
  height: 100%;
}

.board_spinner__hstXC {
  width: 40px;
  height: 40px;
  border: 3px solid var(--spinner-track);
  border-radius: 50%;
  border-top-color: var(--primary);
  animation: board_spin__x4IiZ 1s ease-in-out infinite;
}

@keyframes board_spin__x4IiZ {
  to {
    transform: rotate(360deg);
  }
}
.board_emptyState__1WNxW {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
  width: 100%;
  height: 100%;
  color: var(--text-muted);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/internal/styles/board.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EAEA,mBAAA;EACA,YAAA;EAEA,qCAAA;EACA,6BAAA;EACA,gBAAA;EACA,sBAAA;EAEA,2KACE;EAKF,uDACE;EAGF,eAAA;AAVF;;AAaA;EACE,2BAAA;EACA,yKACE;AAXJ;;AAiBA;EACE,0BAAA;EACA,iGACE;AAfJ;;AAmBA;EACE,WAAA;EACA,wEACE;AAjBJ;;AAqBA;EACE,wEACE;AAnBJ;;AAuBA;EACE,+CACE;AArBJ;;AAwBA;EACE,mBAAA;AArBF;;AAwBA;EACE,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA,EAAA,wDAAA;EACA,gEACE;EAEF,oBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,iCAAA;EACA,6BAAA;AAvBF;;AA0BA;EACE,kBAAA;AAvBF;;AA0BA;EACE,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,gEACE;EAEF,oBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,iCAAA;EACA,6BAAA;AAzBF;;AA4BA;;EAEE,wBAAA;EACA,YAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0CAAA;AAzBF;;AA4BA;EACE,gCAAA;EACA,WAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;AAzBF;;AA4BA;EACE,uBAAA;EACA,2BAAA;AAzBF;;AA4BA;EACE,0BAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AAzBF;;AA4BA;EACE,yBAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAzBF;;AA4BA;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAzBF;;AA4BA;EACE,yBAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAzBF;;AA6BA;EACE,0BAAA;EACA,wBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,qCAAA;EACA,sBAAA;EACA,iBAAA;AA1BF;;AA6BA;EACE,gKAEA;EAIA,mEAAA;EACA,yBAAA;AA/BF;;AAkCA;EACE,gCAAA;EACA,WAAA;AA/BF;;AAkCA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,SAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;AA/BF;;AAmCA;EACE,8BAAA;EACA,sCAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAhCF;;AAmCA;EACE,mCAAA;EACA,qCAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;AAhCF;;AAmCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EAEA,4CAAA;EACA,kEAAA;AAjCF;;AAoCA,kDAAA;AACA;EACE;qEAAA;AAhCF;;AAmCA;EACE;mEAAA;AA/BF;;AAkCA;EACE;oEAAA;AA9BF;;AAiCA;;;EAGE;oEAAA;AA7BF;;AAgCA;EACE;qEAAA;AA5BF;;AA+BA;EACE;oEAAA;AA3BF;;AA8BA;EACE;oEAAA;AA1BF;;AA6BA;EACE;oEAAA;AAzBF;;AA6BA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;AA1BF;;AA8BE;EACE,gEAAA;AA3BJ;AA6BE;EACE;oEAAA;AA1BJ;AA6BE;EACE;mEAAA;AA1BJ;AA6BE;EACE;qEAAA;AA1BJ;AA6BE;;;EAGE;mEAAA;AA1BJ;AA6BE;EACE;oEAAA;AA1BJ;AA6BE;;;EAGE;mEAAA;AA1BJ;;AA+BA;EACE,eAAA;EACA,2BAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EAEA,6CAAA;EACA,wBAAA;EAEA,YAAA;EACA,qBAAA;EACA,wCAAA;EAEA,gCAAA;AA/BF;AAgCE;EACE,WAAA;AA9BJ;AAiCE;EACE,6BAAA;EACA,oBAAA;EACA,6BAAA;AA/BJ;AAkCE;EACE,uBAAA;AAhCJ;AAmCE;EACE,mDAAA;AAjCJ;AAoCE;EACE,wCAAA;EACA,4BAAA;AAlCJ;;AAsCA;EACE,eAAA;EACA,aAAA;AAnCF;;AAsCA;EACE,wBAAA;AAnCF;;AAsCA;EACE,wBAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,2BAAA;AAnCF;;AAsCA;EACE,eAAA;EACA,iBAAA;EACA,0BAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAnCF;;AAsCA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,gCAAA;EACA,oDAAA;AAnCF;;AAsCA;EACE;IACE,yBAAA;EAnCF;AACF;AAsCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;AApCF","sourcesContent":[".page {\n  padding: 16px 16px 0 16px;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.pageDrawerOpen {\n  position: relative;\n}\n\n.pageDrawerOpen::before {\n  content: \"\";\n  position: fixed;\n  top: 52px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--bg-backdrop);\n  z-index: 25;\n  pointer-events: none;\n}\n\n.createIssue {\n  position: absolute;\n  right: 3rem;\n  bottom: 3rem;\n  z-index: 1000;\n  width: 7rem;\n  height: 4rem;\n\n  border-radius: 14px;\n  border: none;\n\n  background: var(--button-bg-gradient);\n  color: var(--text-on-primary);\n  font-weight: 650;\n  letter-spacing: 0.01em;\n\n  box-shadow:\n    6px 6px 14px rgba(0, 0, 0, 0.45),\n    -6px -6px 14px rgba(255, 255, 255, 0.06),\n    inset 1px 1px 2px rgba(255, 255, 255, 0.08),\n    inset -1px -1px 2px rgba(0, 0, 0, 0.2);\n\n  transition:\n    transform 120ms ease,\n    box-shadow 120ms ease;\n\n  cursor: pointer;\n}\n\n.createIssue:hover {\n  transform: translateY(-1px);\n  box-shadow:\n    8px 8px 18px rgba(0, 0, 0, 0.5),\n    -8px -8px 18px rgba(255, 255, 255, 0.08),\n    inset 1px 1px 2px rgba(255, 255, 255, 0.1),\n    inset -1px -1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.createIssue:active {\n  transform: translateY(0px);\n  box-shadow:\n    inset 4px 4px 10px rgba(0, 0, 0, 0.4),\n    inset -4px -4px 10px rgba(255, 255, 255, 0.05);\n}\n\n:global(.internal-root[data-theme=\"light\"]) .createIssue {\n  color: #fff;\n  box-shadow:\n    0 4px 12px rgba(0, 0, 0, 0.15),\n    0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n:global(.internal-root[data-theme=\"light\"]) .createIssue:hover {\n  box-shadow:\n    0 6px 16px rgba(0, 0, 0, 0.2),\n    0 2px 4px rgba(0, 0, 0, 0.12);\n}\n\n:global(.internal-root[data-theme=\"light\"]) .createIssue:active {\n  box-shadow:\n    inset 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.issueTitleContainer {\n  margin-bottom: 12px;\n}\n\n.issueTitleText {\n  background: var(--fill-subtle);\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border-default);\n  border-radius: 6px;\n  resize: none;\n  color: var(--text-primary);\n  font-size: 14px;\n  font-weight: 600;\n  min-height: 42px;\n  height: 42px; /* Force single line initially, though it's a textarea */\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n  font-family: inherit;\n}\n\n.issueTitleText:focus {\n  outline: none;\n  border-color: var(--border-focus);\n  background: var(--fill-light);\n}\n\n.issueDescriptionContainer {\n  margin-bottom: 8px;\n}\n\n.issueDescriptionText {\n  background: var(--fill-subtle);\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid var(--border-default);\n  border-radius: 6px;\n  resize: vertical;\n  color: var(--text-primary);\n  font-size: 13px;\n  min-height: 120px;\n  transition:\n    border-color 0.15s ease,\n    background-color 0.15s ease;\n  font-family: inherit;\n}\n\n.issueDescriptionText:focus {\n  outline: none;\n  border-color: var(--border-focus);\n  background: var(--fill-light);\n}\n\n.issueTitleText::placeholder,\n.issueDescriptionText::placeholder {\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n.createIssueActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-subtle);\n}\n\n.createIssuePrimary {\n  background-color: var(--primary);\n  color: #fff;\n  border: 1px solid transparent;\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.createIssuePrimary:hover {\n  filter: brightness(1.1);\n  transform: translateY(-1px);\n}\n\n.createIssuePrimary:active {\n  transform: translateY(0px);\n}\n\n.createIssuePrimary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  filter: grayscale(0.5);\n}\n\n.createIssueError {\n  color: var(--color-error);\n  margin-top: 8px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.backArrowLink {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.backArrow {\n  height: 16px;\n  width: 16px;\n  margin-right: 5px;\n}\n\n.error {\n  color: var(--color-error);\n  margin: 8px 0 12px;\n}\n\n.filterOptionsContainer {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n\n}\n\n.filterOption {\n  background: var(--bg-base);\n  color: var(--text-muted);\n  border-radius: 8px;\n  padding-inline: 0.8rem;\n  padding-block: 0.5rem;\n  cursor: pointer;\n  font-size: 13px;\n  border: 1px solid var(--border-color);\n  will-change: transform;\n  min-width: 2.5rem;\n}\n\n.filterOption:hover:not(.filterOptionActive) {\n  background: \n  /* Top layer: inner card color */\n  linear-gradient(var(--bg-raised), var(--bg-surface)) padding-box,\n  /* Bottom layer: the gradient you wanted */\n  linear-gradient(to bottom, var(--highlight-color), var(--border-color)) border-box;\n\n  /* Ensure the border is transparent so the gradient shows through */\n  border-color: transparent;\n}\n\n.filterOptionActive {\n  background-color: var(--primary);\n  color: #fff;\n}\n\n.boardContainer {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.board {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: 280px;\n  gap: 12px;\n  flex: 1;\n  min-height: 0;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  padding-bottom: 8px;\n  scrollbar-gutter: stable;\n}\n\n\n.column {\n  background: var(--fill-subtle);\n  border: 1px solid var(--border-subtle);\n  border-radius: 12px;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n}\n\n.column:hover {\n  background: var(--bg-raised-purple);\n  border: 1px solid var(--border-color);\n}\n\n.columnHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.columnTitle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-strong);\n\n  /* Default: make all column icons brighter */\n  --board-icon-filter: brightness(1.25) saturate(1.6) contrast(1.15);\n}\n\n/* Per-column icon filter hook (override in CSS) */\n.columnTitle[data-state-key=\"in progress\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(99%) sepia(65%)\n    saturate(5941%) hue-rotate(323deg) brightness(115%) contrast(95%);\n}\n.columnTitle[data-state-key=\"in review\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(51%) sepia(67%)\n    saturate(381%) hue-rotate(70deg) brightness(120%) contrast(95%);\n}\n.columnTitle[data-state-key=\"done\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(44%) sepia(78%)\n    saturate(482%) hue-rotate(197deg) brightness(115%) contrast(95%);\n}\n.columnTitle[data-state-key=\"canceled\"],\n.columnTitle[data-state-key=\"cancelled\"],\n.columnTitle[data-state-key=\"duplicate\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(74%) sepia(7%)\n    saturate(619%) hue-rotate(175deg) brightness(115%) contrast(95%);\n}\n.columnTitle[data-state-key=\"triage\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(56%) sepia(55%)\n    saturate(1002%) hue-rotate(331deg) brightness(120%) contrast(95%);\n}\n.columnTitle[data-state-key=\"todo\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)\n    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);\n}\n.columnTitle[data-state-key=\"backlog\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)\n    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);\n}\n.columnTitle[data-state-key=\"extended features\"] {\n  --board-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)\n    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);\n}\n\n.columnIcon {\n  width: 14px;\n  height: 14px;\n  opacity: 0.9;\n  filter: var(--board-icon-filter, none);\n}\n\n:global(.internal-root[data-theme=\"light\"]) {\n  .columnTitle {\n    --board-icon-filter: brightness(0.8) saturate(1.4) contrast(1.1);\n  }\n  .columnTitle[data-state-key=\"in progress\"] {\n    --board-icon-filter: brightness(0) saturate(100%) invert(65%) sepia(65%)\n      saturate(5941%) hue-rotate(323deg) brightness(85%) contrast(95%);\n  }\n  .columnTitle[data-state-key=\"in review\"] {\n    --board-icon-filter: brightness(0) saturate(100%) invert(42%) sepia(67%)\n      saturate(500%) hue-rotate(70deg) brightness(105%) contrast(90%);\n  }\n  .columnTitle[data-state-key=\"done\"] {\n    --board-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(80%)\n      saturate(1500%) hue-rotate(197deg) brightness(85%) contrast(100%);\n  }\n  .columnTitle[data-state-key=\"canceled\"],\n  .columnTitle[data-state-key=\"cancelled\"],\n  .columnTitle[data-state-key=\"duplicate\"] {\n    --board-icon-filter: brightness(0) saturate(100%) invert(40%) sepia(7%)\n      saturate(619%) hue-rotate(175deg) brightness(90%) contrast(95%);\n  }\n  .columnTitle[data-state-key=\"triage\"] {\n    --board-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(55%)\n      saturate(1002%) hue-rotate(331deg) brightness(90%) contrast(95%);\n  }\n  .columnTitle[data-state-key=\"todo\"],\n  .columnTitle[data-state-key=\"backlog\"],\n  .columnTitle[data-state-key=\"extended features\"] {\n    --board-icon-filter: brightness(0) saturate(100%) invert(30%) sepia(1%)\n      saturate(209%) hue-rotate(72deg) brightness(70%) contrast(100%);\n  }\n}\n\n.columnCount {\n  font-size: 12px;\n  color: var(--text-tertiary);\n}\n\n.columnBody {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n\n  /* Keep layout stable even when no overflow */\n  scrollbar-gutter: stable;\n\n  /* Firefox */\n  scrollbar-width: auto;\n  scrollbar-color: transparent transparent;\n\n  /* WebKit (Chrome/Safari/Edge) */\n  &::-webkit-scrollbar:vertical {\n    width: 10px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: transparent;\n    border-radius: 999px;\n    border: 2px solid transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &:hover {\n    scrollbar-color: var(--highlight-color) transparent;\n  }\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: var(--highlight-color);\n    border-color: var(--bg-base);\n  }\n}\n\n.card {\n  cursor: pointer;\n  padding: 10px;\n}\n\n.card:hover {\n  filter: brightness(1.03);\n}\n\n:global(.internal-root[data-theme=\"light\"]) .card:hover {\n  filter: brightness(0.97);\n}\n\n.cardTop {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.identifier {\n  font-size: 11px;\n  color: var(--text-tertiary);\n}\n\n.cardTitle {\n  font-size: 13px;\n  line-height: 1.35;\n  color: var(--text-heading);\n}\n\n.loadingContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--spinner-track);\n  border-radius: 50%;\n  border-top-color: var(--primary);\n  animation: spin 1s ease-in-out infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.emptyState {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  color: var(--text-muted);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `board_page__-3I0O`,
	"pageDrawerOpen": `board_pageDrawerOpen__cDIS0`,
	"createIssue": `board_createIssue__JNWCD`,
	"issueTitleContainer": `board_issueTitleContainer__kM-Wj`,
	"issueTitleText": `board_issueTitleText__aNDvW`,
	"issueDescriptionContainer": `board_issueDescriptionContainer__cr-l5`,
	"issueDescriptionText": `board_issueDescriptionText__Xa8Q4`,
	"createIssueActions": `board_createIssueActions__FDPu2`,
	"createIssuePrimary": `board_createIssuePrimary__tKbz9`,
	"createIssueError": `board_createIssueError__yn2Te`,
	"header": `board_header__S3U3u`,
	"backArrowLink": `board_backArrowLink__XkrUX`,
	"title": `board_title__jOGAN`,
	"backArrow": `board_backArrow__aLVaD`,
	"error": `board_error__bWV7J`,
	"filterOptionsContainer": `board_filterOptionsContainer__Jaict`,
	"filterOption": `board_filterOption__vRdsO`,
	"filterOptionActive": `board_filterOptionActive__WNP1c`,
	"boardContainer": `board_boardContainer__4EBGA`,
	"board": `board_board__Hd6z-`,
	"column": `board_column__gyRV3`,
	"columnHeader": `board_columnHeader__ZwsL9`,
	"columnTitle": `board_columnTitle__TyArK`,
	"columnIcon": `board_columnIcon__Ofna6`,
	"columnCount": `board_columnCount__vKbS7`,
	"columnBody": `board_columnBody__XtBJh`,
	"card": `board_card__b9Jrk`,
	"cardTop": `board_cardTop__ALEuM`,
	"identifier": `board_identifier__viOJQ`,
	"cardTitle": `board_cardTitle__2iU7O`,
	"loadingContainer": `board_loadingContainer__35s18`,
	"spinner": `board_spinner__hstXC`,
	"spin": `board_spin__x4IiZ`,
	"emptyState": `board_emptyState__1WNxW`
};
export default ___CSS_LOADER_EXPORT___;
